var exports = {
  "sM": "DiscoveryBannerTint.module__bannerTint___WG94V3",
  "pW": "DiscoveryBannerTint.module__bannerTintViolet___WG94V3" + " " + "DiscoveryBannerTint.module__bannerTint___WG94V3",
  "wi": "DiscoveryBannerTint.module__bannerTintBlue___WG94V3" + " " + "DiscoveryBannerTint.module__bannerTint___WG94V3",
  "gp": "DiscoveryBannerTint.module__bannerTintTeal___WG94V3" + " " + "DiscoveryBannerTint.module__bannerTint___WG94V3",
  "ZQ": "DiscoveryBannerTint.module__bannerTintGreen___WG94V3" + " " + "DiscoveryBannerTint.module__bannerTint___WG94V3",
  "j8": "DiscoveryBannerTint.module__bannerTintLime___WG94V3" + " " + "DiscoveryBannerTint.module__bannerTint___WG94V3",
  "LJ": "DiscoveryBannerTint.module__bannerTintAmber___WG94V3" + " " + "DiscoveryBannerTint.module__bannerTint___WG94V3",
  "zg": "DiscoveryBannerTint.module__bannerTintCoral___WG94V3" + " " + "DiscoveryBannerTint.module__bannerTint___WG94V3",
  "zv": "DiscoveryBannerTint.module__bannerTintRose___WG94V3" + " " + "DiscoveryBannerTint.module__bannerTint___WG94V3",
  "$B": "DiscoveryBannerTint.module__bannerTintMagenta___WG94V3" + " " + "DiscoveryBannerTint.module__bannerTint___WG94V3",
  "KS": "DiscoveryBannerTint.module__bannerTintIndigo___WG94V3" + " " + "DiscoveryBannerTint.module__bannerTint___WG94V3",
};

module.exports = exports;
